import { render, staticRenderFns } from "./notifications.vue?vue&type=template&id=5caa06ca&scoped=true"
import script from "./notifications.vue?vue&type=script&setup=true&lang=js"
export * from "./notifications.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5caa06ca",
  null
  
)

export default component.exports